








































import { Component, Watch, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import BrandMixin from "@/mixins/brandMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ConfirmModalModes } from "@/data/enums";

@Component
export default class BrandSettings extends Mixins(BrandMixin) {
  // Data

  public isLoading = true;
  public isReloading = false;
  public isProcessing = false;
  public requestError = false;

  public hasDemoData = false;

  // Life-cycle methods

  public async created() {
    if (!this.contentIsAvailable) return;

    this.isLoading = true;
    this.loadData();
  }

  // Methods

  public async loadData() {
    try {
      await this.getBrand();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public async reloadData() {
    this.isReloading = true;
    await this.loadData();
  }

  public getBrand() {
    return this.$store.dispatch("brand/get", { ignoreStored: true });
  }

  public async seedDemoData() {
    if (this.hasDemoData || !this.canSeedDemoData) return;

    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: true,
          mode: ConfirmModalModes.BUTTON,
          type: "is-success",
          title: this.$t("_sentence.settings.confirm_seed_demo_data_action"),
          message: this.$t(
            "_sentence.settings.confirm_seed_demo_data_action_desc"
          ),
          confirmButtonText: this.$t("_action.seed_demo_data")
        },
        events: {
          confirmed: async () => {
            try {
              this.isProcessing = true;
              await this.$store.dispatch(
                `data/${DataModules.BRANDS}/seedDemoData`,
                {
                  brandId: this.brandId
                }
              );
              await this.reloadData();
              this.$store.dispatch(`demoData/checkImportStatus`);
              confirm.close();
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              this.isProcessing = false;
            }
          }
        }
      }
    });
  }

  public async deleteDemoData() {
    if (!this.hasDemoData || !this.canDeleteDemoData) return;

    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: true,
          mode: ConfirmModalModes.BUTTON,
          title: this.$t("_sentence.settings.confirm_delete_demo_data_action"),
          message: this.$t(
            "_sentence.settings.confirm_delete_demo_data_action_desc"
          ),
          confirmButtonText: this.$t("_action.remove_demo_data")
        },
        events: {
          confirmed: async () => {
            try {
              this.isProcessing = true;

              await this.$store.dispatch(
                `data/${DataModules.BRANDS}/deleteDemoData`,
                {
                  brandId: this.brandId
                }
              );
              await this.reloadData();

              this.$store.dispatch("toast/show", {
                message: this.$t(
                  "_sentence.settings.demo_data_successfully_deleted"
                )
              });

              confirm.close();
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              this.isProcessing = false;
            }
          }
        }
      }
    });
  }

  // Computed

  public get canSeedDemoData() {
    return this.$userCan("create_demo_data_import");
  }

  public get canDeleteDemoData() {
    return this.$userCan("delete_demo_data_import");
  }

  // Guarding

  public guardFunctionalities = ["get_brand"];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  // Watchers

  @Watch("brand", { deep: true, immediate: true })
  public onBrandChange() {
    this.hasDemoData = _.get(this.brand, "has_demo_data");
  }
}
